/**
 * Fichero para la creación de un objeto accesible con un import
 * desde cualquier componente o acción de la aplicación
 * con la configuración de la aplicación
 */

const config = require("./configuracion.json");

export default config;
